<template>
  <div class="home">
    <div id="nav">
         <img  class="imgexit" @click="logout" src="../assets/exit.png" >
    </div>

    <ThermoCompo v-for="device in devices" :key="device" :ThermoD="device"/>




  </div>
</template>

<script>
// @ is an alias to /src

import ThermoCompo from '@/components/ThermoCompo.vue'
import firebase from 'firebase';
export default {
  name: 'thermo',
  data() {
      return {
        mensaje:'',
        devices: [],
      };
    },
  components: {
    ThermoCompo
  },
   created(){
    this.mensaje ='tototototot'
    },
    async beforeCreate() {
      let user = await firebase.auth().currentUser;
      if (!user) {
        this.$router.replace("/");
      } else {
        let url = "usuarios/" + user.uid + "/devices";
        let snapshot = await firebase.database().ref(url).once("value")
        if (snapshot.val()) {
          this.devices = snapshot.val()
        }
      }
    },
  methods: {
    logout: function() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('/')
      })
    },


  }
}
</script>

<style scoped>
 .imgexit{
    width: 25px;
    position: absolute;
    cursor: pointer;
 }
</style>
